// GSAP Animations Configuration
document.addEventListener('DOMContentLoaded', function() {
  // Register GSAP plugins
  gsap.registerPlugin(ScrollTrigger);

  // Set default ease
  gsap.defaults({
    ease: "power2.out",
    duration: 1
  });

  // Hero Section Animations
  function initHeroAnimations() {
    const heroTitle = document.querySelector('.hero__title');
    const heroSubtitle = document.querySelector('.hero__subtitle');
    const heroDescription = document.querySelector('.hero__description');
    const heroCta = document.querySelector('.hero__cta');
    const heroScroll = document.querySelector('.hero__scroll-indicator');

    if (heroTitle) {
      gsap.fromTo(heroTitle, 
        { y: 100, opacity: 0 },
        { y: 0, opacity: 1, duration: 1.2, ease: "power3.out" }
      );
    }

    if (heroSubtitle) {
      gsap.fromTo(heroSubtitle,
        { y: 50, opacity: 0 },
        { y: 0, opacity: 1, duration: 1, delay: 0.3, ease: "power2.out" }
      );
    }

    if (heroDescription) {
      gsap.fromTo(heroDescription,
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, delay: 0.6, ease: "power2.out" }
      );
    }

    if (heroCta) {
      gsap.fromTo(heroCta,
        { y: 30, opacity: 0, scale: 0.9 },
        { y: 0, opacity: 1, scale: 1, duration: 0.8, delay: 0.9, ease: "back.out(1.7)" }
      );
    }

    if (heroScroll) {
      gsap.fromTo(heroScroll,
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, delay: 1.2, ease: "power2.out" }
      );
    }
  }

  // Services Section Animations
  function initServicesAnimations() {
    const serviceCards = document.querySelectorAll('.service-card');
    
    serviceCards.forEach((card, index) => {
      gsap.fromTo(card,
        { y: 100, opacity: 0, scale: 0.9 },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.8,
          delay: index * 0.1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: card,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none reverse"
          }
        }
      );

      // 3D tilt effect on hover
      card.addEventListener('mousemove', function(e) {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rotateX = (y - centerY) / 10;
        const rotateY = (centerX - x) / 10;

        gsap.to(card, {
          rotationX: rotateX,
          rotationY: rotateY,
          duration: 0.3,
          ease: "power2.out"
        });
      });

      card.addEventListener('mouseleave', function() {
        gsap.to(card, {
          rotationX: 0,
          rotationY: 0,
          duration: 0.5,
          ease: "power2.out"
        });
      });
    });
  }

  // Process Section Animations
  function initProcessAnimations() {
    const processSteps = document.querySelectorAll('.process__step');
    const progressBar = document.querySelector('.process__progress');

    processSteps.forEach((step, index) => {
      gsap.fromTo(step,
        { x: index % 2 === 0 ? -100 : 100, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          delay: index * 0.2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: step,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });

    // Progress bar animation
    if (progressBar) {
      gsap.fromTo(progressBar,
        { height: "0%" },
        {
          height: "100%",
          duration: 2,
          ease: "power2.out",
          scrollTrigger: {
            trigger: ".process__timeline",
            start: "top 80%",
            end: "bottom 20%",
            scrub: 1
          }
        }
      );
    }
  }

  // About Section Animations
  function initAboutAnimations() {
    const aboutText = document.querySelector('.about__text');
    const aboutVisual = document.querySelector('.about__visual');
    const aboutStats = document.querySelectorAll('.about__stat');

    if (aboutText) {
      gsap.fromTo(aboutText,
        { x: -100, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: aboutText,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none reverse"
          }
        }
      );
    }

    if (aboutVisual) {
      gsap.fromTo(aboutVisual,
        { x: 100, opacity: 0, scale: 0.9 },
        {
          x: 0,
          opacity: 1,
          scale: 1,
          duration: 1,
          delay: 0.3,
          ease: "power2.out",
          scrollTrigger: {
            trigger: aboutVisual,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none reverse"
          }
        }
      );
    }

    // Counter animations
    aboutStats.forEach((stat, index) => {
      const numberElement = stat.querySelector('.about__stat-number');
      const targetNumber = parseInt(numberElement.getAttribute('data-count'));
      
      gsap.fromTo(stat,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          delay: index * 0.1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: stat,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none reverse"
          }
        }
      );

      // Counter animation
      gsap.fromTo(numberElement,
        { textContent: 0 },
        {
          textContent: targetNumber,
          duration: 2,
          ease: "power2.out",
          snap: { textContent: 1 },
          scrollTrigger: {
            trigger: stat,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });
  }

  // Contact Section Animations
  function initContactAnimations() {
    const contactInfo = document.querySelector('.contact__info');
    const contactForm = document.querySelector('.contact__form-container');

    if (contactInfo) {
      gsap.fromTo(contactInfo,
        { x: -100, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: contactInfo,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none reverse"
          }
        }
      );
    }

    if (contactForm) {
      gsap.fromTo(contactForm,
        { x: 100, opacity: 0, scale: 0.9 },
        {
          x: 0,
          opacity: 1,
          scale: 1,
          duration: 1,
          delay: 0.3,
          ease: "power2.out",
          scrollTrigger: {
            trigger: contactForm,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none reverse"
          }
        }
      );
    }
  }

  // Parallax Effects
  function initParallaxEffects() {
    // Hero parallax
    gsap.to('.hero__particles', {
      yPercent: -50,
      ease: "none",
      scrollTrigger: {
        trigger: '.hero',
        start: "top bottom",
        end: "bottom top",
        scrub: true
      }
    });

    // About section parallax
    gsap.to('.about__visual', {
      yPercent: -30,
      ease: "none",
      scrollTrigger: {
        trigger: '.about',
        start: "top bottom",
        end: "bottom top",
        scrub: true
      }
    });
  }

  // Magnetic Cursor Effect
  function initMagneticCursor() {
    const magneticElements = document.querySelectorAll('.hero__cta, .service-card, .contact__form-submit');
    
    magneticElements.forEach(element => {
      element.addEventListener('mousemove', function(e) {
        const rect = element.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        
        gsap.to(element, {
          x: x * 0.1,
          y: y * 0.1,
          duration: 0.3,
          ease: "power2.out"
        });
      });
      
      element.addEventListener('mouseleave', function() {
        gsap.to(element, {
          x: 0,
          y: 0,
          duration: 0.5,
          ease: "power2.out"
        });
      });
    });
  }

  // Text Reveal Animations
  function initTextRevealAnimations() {
    const textElements = document.querySelectorAll('[data-animate="title"], [data-animate="subtitle"], [data-animate="description"]');
    
    textElements.forEach(element => {
      const text = element.textContent;
      element.innerHTML = text.split('').map(char => 
        char === ' ' ? ' ' : `<span style="display: inline-block;">${char}</span>`
      ).join('');
      
      const spans = element.querySelectorAll('span');
      
      gsap.fromTo(spans,
        { y: 100, opacity: 0, rotationX: 90 },
        {
          y: 0,
          opacity: 1,
          rotationX: 0,
          duration: 0.8,
          stagger: 0.02,
          ease: "power2.out",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });
  }

  // Initialize all animations
  function initAllAnimations() {
    initHeroAnimations();
    initServicesAnimations();
    initProcessAnimations();
    initAboutAnimations();
    initContactAnimations();
    initParallaxEffects();
    initMagneticCursor();
    initTextRevealAnimations();
  }

  // Start animations
  initAllAnimations();

  // Refresh ScrollTrigger on window resize
  window.addEventListener('resize', () => {
    ScrollTrigger.refresh();
  });
});


